<template>
    <Modal :allow-close="visible" :hide-actions="true" rounded-size="rounded-3xl" max-width="sm:max-w-2xl" @modal:close="handleClose()">
        <template #body>
                <h1  class="mt-2 text-3xl text-center font-semibold mb-8 text-won-blue">
                    Our Terms of Use and Privacy Policy
                </h1>

                <div class="flex justify-center flex-col cursor-pointer">
                    <div>
                        <checkbox-element
                          v-model="acceptTermsCondition"
                          id="termsCondition"
                          label="I accept the Terms of Use and Privacy Policy."
                        />
                        <div v-if="showError" class="text-[12px] px-6 text-red-500">To access WonsultingAI, review and accept our terms of use and privacy policy.</div>
                   </div>
                </div>

                <p class="text-sm text-left mt-10 text-gray-500 mb-4">
                    By clicking ‘Submit,’ I agree to the Wonsulting Inc’s
                    <a href="https://www.wonsulting.ai/terms-and-conditions" class="cursor-pointer underline text-blue-500" target="_blank">Terms of Use</a>
                    &
                    <a href="https://www.wonsulting.ai/privacy-policy"  class="underline cursor-pointer text-blue-500" target="_blank">Privacy Policy</a>
                </p>

                <div class="my-6 flex justify-center">
                    <won-button @click="() => handleNext()" class="w-48 disabled:bg-won-gray" :disabled="!acceptTermsCondition">
                        <LoadingSpinner
                            v-if="submitting"
                        />
                        Submit
                    </won-button>
                </div>
        </template>
    </Modal>
</template>

<script setup>
import Modal from "../../components/modal";
import WonButton from "../../components/won-button.vue";
import { useNotifications } from '../../store/notifications.store'
import {ref} from 'vue'

const submitting = ref(false)
const acceptTermsCondition = ref(false)
const showError = ref(false)
const emit = defineEmits(['terms-condition:accepted'])
import { update } from '../../api/profile'
import CheckboxElement from "../../forms/elements/checkbox.vue";
import LoadingSpinner from "../../icons/loading-spinner.vue";
const notificationStore =  useNotifications()

const props = defineProps({
    visible: {
        type: Boolean,
        default: false,
    },
})

const handleNext = () => {
    submitting.value = true
    setTimeout(() => {

        if (!acceptTermsCondition.value) {
            showError.value = true;
            submitting.value = false
            return;
        }
        
        handleClose()
        showError.value = false;
        submitting.value = false
        
        update('terms_accepted_at', new Date()).then(() => {
            notificationStore.notify('Successfully accepted the terms and condition')
        }) 
    }, 500)
}

const handleClose = async () => {
    emit("terms-condition:accepted");
}
</script>
